<script lang="ts">
  import { onMount } from "svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import { Table } from "../../components/Table";
  import { initList, loading, records, onDelete, onEdit, onCreate, uploading, uploadLogotype, newLogo, onDownloadLogotype } from "./customer-logotype.store";
  import { customerLogotypeSummaryDtoFields } from "../../utils/TableFields/customer-logotype-summary-dto.fields";
  import { isUserRoleADM } from "../../app.store";
  import Label from "../../components/Form/Label.svelte";
  import FileUploadButton from "../../components/FileUploadButton.svelte";

  export let customerId: number;

  $: isNew = customerId == 0;

  onMount(() => initList(customerId));
</script>

{#if !!customerId}
  {#if $newLogo}
    <div class="columns" style="height: unset;">
      <div class="column is-12">
        <FormField>
          <Label>&nbsp;</Label>
          <div>
            <FileUploadButton text="Carica logo..." disabled={$uploading} on:fileUpload={(e) => uploadLogotype(customerId, e)} />
            {#if $uploading}
              <i class="material-icons">hourglass_bottom</i>
            {/if}
          </div>
        </FormField>
      </div>
    </div>
  {/if}

  <Table
    loading={$loading}
    fields={customerLogotypeSummaryDtoFields}
    records={$records}
    createEnabled={true}
    editEnabled={false}
    deleteEnabled={$isUserRoleADM}
    exportRecordEnabled={true}
    on:create={(e) => onCreate(customerId)}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
    on:exportRecord={(e) => onDownloadLogotype(e.detail)}
  />
{/if}
